import { render, staticRenderFns } from "./ResorcesTab.vue?vue&type=template&id=6a3c28ae&"
import script from "./ResorcesTab.vue?vue&type=script&lang=js&"
export * from "./ResorcesTab.vue?vue&type=script&lang=js&"
import style0 from "./ResorcesTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports